import { CardContent, Divider, styled, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Column, Row } from 'further-ui/components/Layout';
import { numberToCurrencyString } from 'further-ui/utils';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm, theme.spacingSizes.md),
}));

type Props = {
  currencyLcy: CurrencyCode;
  data: Array<{ label: string; value: number }>;
};

const CounterpartyBreakdown: React.FC<Props> = ({ currencyLcy, data }) => {
  return (
    <StyledCard variant="outlined">
      <StyledCardContent>
        <Column spacing="sm">
          <Column spacing="xs">
            <Row justify="space-between">
              <Typography variant="h6" color="grey.600">
                Counterparty
              </Typography>
              <Typography variant="h6" color="grey.600">
                Amount
              </Typography>
            </Row>
            <Divider />
          </Column>
          {data.map((item) => (
            <Row key={item.label} justify="space-between">
              <Typography variant="h6">{item.label}</Typography>
              <Typography variant="h6">
                {numberToCurrencyString(item.value, { currency: currencyLcy })}
              </Typography>
            </Row>
          ))}
        </Column>
      </StyledCardContent>
    </StyledCard>
  );
};

export default CounterpartyBreakdown;
